import React, { PureComponent, PropTypes } from 'react';
import { extractDivisionName } from '../../util/EventUtil';
import { commonPropTypes, EMPTY_TABLE_CELL } from '../../util/constants';

export default class EventDivisionName extends PureComponent {

  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE.isRequired
  };

  render() {
    const { event } = this.props;
    return <span style={{ wordBreak: 'break-all' }}>{extractDivisionName(event) || EMPTY_TABLE_CELL}</span>;
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventDivisionName.jsx